import { render, staticRenderFns } from "./h4.vue?vue&type=template&id=77074fba&"
import script from "./h4.vue?vue&type=script&lang=js&"
export * from "./h4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports